module.exports = __webpack_public_path__ + "static/media/order_type_app_android.554c34e6.svg";